const firebaseConfig = {
  apiKey: 'AIzaSyA5Zm-WLYkiUtP-8wpB4b6RIKyoSiAVpL8',
  authDomain: 'quieter-app.firebaseapp.com',
  projectId: 'quieter-app',
  storageBucket: 'quieter-app.appspot.com',
  messagingSenderId: '174238196952',
  appId: '1:174238196952:web:1d077421f8c9214b8163ad',
};

export default firebaseConfig;
